import React from 'react';
import { Button, Box, CircularProgress } from '@material-ui/core';

interface buttonProps {
  onClick: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) | undefined;
  text: string;
  isProgress: boolean;
}

export const MyButton = (props: buttonProps) => {
  const { onClick, text, isProgress } = props;

  return (
    <Box display="flex" alignItems="center" pt={1}>
      <Button variant="contained" disabled={isProgress} onClick={onClick} color="primary">
        {text}
      </Button>
      <Box pl={1} display="inline"></Box>
      {isProgress && <CircularProgress size="1.8rem" />}
    </Box>
  );
};
